import "./styles.scss";

// eslint-disable-next-line no-unused-vars
import Chart from "chart.js/auto";
import React, { useMemo, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

import ChartSummaryAlert from "./partials/ChartSummaryAlert";
import ChartSummaryMetrics from "./partials/ChartSummaryMetrics";

const ChannelSummaryComponent = (props) => {
  const { getGraphData, getAlerts } = props;
  const [tabIndex, setTabIndex] = useState(1);
  const { search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);

  if (!params.has("channelId") && !params.has("region") && !params.has("streamId") && !params.has("sourceArn")) {
    return <Navigate to="/dashboard" />;
  }
  const region = params.get("region");
  const channelId = params.get("channelId");
  const streamId = params.get("streamId");
  const sourceArn = params.get("sourceArn");
  const timeStamp = params.get("timeStamp");
  const streamStartTime = params.get("streamStartTime");
  const streamEndTime = params.get("streamEndTime");

  const _temp = Chart; // for removing eslint error of importing chart js
  return (
    <>
      <main className="main">
        <div className="page-toolbar border-0">
          <div className="page-breadcrumbs-styled">
            <div>
              <div className="page-title">Channel Summary</div>
            </div>
          </div>
        </div>
        <div className="tab-container-cs">
          <button className={tabIndex === 0 ? "active" : ""} onClick={() => setTabIndex(0)}>
            Alerts
          </button>
          <button className={tabIndex === 1 ? "active" : ""} onClick={() => setTabIndex(1)}>
            Channel Metrics
          </button>
        </div>
        {tabIndex === 0 && (
          <ChartSummaryAlert getAlerts={getAlerts} region={region} channelId={channelId} streamId={streamId} />
        )}
        {tabIndex === 1 && (
          <ChartSummaryMetrics
            getGraphData={getGraphData}
            region={region}
            channelId={channelId}
            sourceArn={sourceArn}
            timeStamp={timeStamp ?? 0}
            streamStartTime={streamStartTime}
            streamEndTime={streamEndTime}
          />
        )}
      </main>
    </>
  );
};
export default ChannelSummaryComponent;
